import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { FaHouse } from 'react-icons/fa6';
import { getRouteMeta } from '../routeMeta';
import '../mobile.css';

// The native Stack Navigator chrome every mobile screen gets for free
// (back arrow, title, "home" icon back to MyCases) - centralized here instead
// of repeating it in every screen component.
const ScreenHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const meta = getRouteMeta(location.pathname);

  const title = meta.title ?? (location.state?.title || '');

  if (!meta.showBack && !meta.showHome && !title) return null;

  return (
    <div className="m-screen-header">
      <button
        onClick={() => navigate(-1)}
        className="m-screen-header-btn"
        style={{ visibility: meta.showBack ? 'visible' : 'hidden' }}
        aria-label="Go back"
      >
        <FaArrowLeft size={18} color="#094268" />
      </button>

      <span className="m-screen-header-title">{title}</span>

      <button
        onClick={() => navigate('/m/cases')}
        className="m-screen-header-btn"
        style={{ visibility: meta.showHome ? 'visible' : 'hidden' }}
        aria-label="Go to case list"
      >
        <FaHouse size={18} color="#094268" />
      </button>
    </div>
  );
};

export default ScreenHeader;
